import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import { Provider } from "react-redux";
import store from "./redux/store/configureStore";

import "./App.css";
import PublicRoutes from "./Routes/PublicRoutes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
     
      <BrowserRouter>
        <PublicRoutes/>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
